// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  background-color: rgb(36, 36, 36);
  height: 80px;
  font-size: 19px;
}

.navbar-toggler {
  background-color: rgb(255, 255, 255);
  padding: 5px;
}

.navbar-brand:hover {
  color: white;
  font-weight: bolder;
  text-shadow: 0px 0px 2px rgb(255, 255, 255);
}

.nav-logo {
  max-height: 60px;
  max-width: 200px;
  padding: 4px;
  z-index: 1;
}

a {
  color: rgb(255, 255, 255) !important;
  transition: all 0.2s ease-in-out;
}

.dropdown-menu {
  background-color: rgb(88, 88, 88);
  border: 1px, solid, white;
  color: white;
}

.dropdown-menu .dropdown-item:hover {
  background-color: rgb(46, 44, 44);
  border: 1px, solid, white;
  font-weight: 510;
}

@media (min-width: 1385px) {
  .navbar-expand-2xl {
    flex-wrap: nowrap !important;
    justify-content: flex-start !important;
  }
  .navbar-expand-2xl .navbar-collapse {
    display: flex !important;
  }
  .collapse:not(.show) {
    display: none;
  }
  .navbar-expand-2xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-2xl .navbar-toggler {
    display: none;
  }
  ul li {
    padding-left: 8px;
    padding-left: 8px;
  }
  .navbar-expand-2xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .navbar-expand-2xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  a:hover {
    color: white !important;
    font-weight: 510;
    transform: scale(1.03);
  }
}
@media (max-width: 1385px) {
  .navbar-toggler {
    background-color: rgb(255, 255, 255);
    color: black;
    padding: 15px;
  }
  .navbar-collapse {
    flex-basis: 0%;
    flex-grow: 1;
    background-color: rgb(36, 36, 36);
    width: 100%;
    padding-left: 50%;
  }
  .collapse:not(.show) {
    display: none;
  }
  .mobile-spacing {
    margin-bottom: 15px;
    margin-top: 15px;
  }
  .mobile-button {
    padding: 15px;
    font-size: x-large;
  }
  a {
    font-size: x-large;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/navbar/navbar.component.scss"],"names":[],"mappings":"AAAA;EACE,iCAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,oCAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,2CAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AACF;;AAEA;EACE,oCAAA;EACA,gCAAA;AACF;;AAEA;EACE,iCAAA;EACA,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,iCAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAGA;EACE;IACE,4BAAA;IACA,sCAAA;EAAF;EAGA;IACE,wBAAA;EADF;EAIA;IACE,aAAA;EAFF;EAKA;IACE,mBAAA;EAHF;EAMA;IACE,aAAA;EAJF;EAOA;IACE,iBAAA;IACA,iBAAA;EALF;EAQA;IACE,kBAAA;EANF;EASA;IACE,2BAAA;EAPF;EAUA;IACE,kDAAA;IACA,iDAAA;EARF;EAWA;IACE,uBAAA;IACA,gBAAA;IACA,sBAAA;EATF;AACF;AAcA;EACE;IACE,oCAAA;IACA,YAAA;IACA,aAAA;EAZF;EAeA;IACE,cAAA;IACA,YAAA;IACA,iCAAA;IACA,WAAA;IACA,iBAAA;EAbF;EAgBA;IACE,aAAA;EAdF;EAiBA;IACE,mBAAA;IACA,gBAAA;EAfF;EAkBA;IACE,aAAA;IACA,kBAAA;EAhBF;EAmBA;IACE,kBAAA;EAjBF;AACF","sourcesContent":[".navbar {\r\n  background-color: rgb(36, 36, 36);\r\n  height: 80px;\r\n  font-size: 19px;\r\n}\r\n\r\n.navbar-toggler {\r\n  background-color: rgb(255, 255, 255);\r\n  padding: 5px;\r\n}\r\n\r\n.navbar-brand:hover {\r\n  color: white;\r\n  font-weight: bolder;\r\n  text-shadow: 0px 0px 2px rgb(255, 255, 255);\r\n}\r\n\r\n.nav-logo {\r\n  max-height: 60px;\r\n  max-width: 200px;\r\n  padding: 4px;\r\n  z-index: 1;\r\n}\r\n\r\na {\r\n  color: rgb(255, 255, 255) !important;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.dropdown-menu {\r\n  background-color: rgb(88, 88, 88);\r\n  border: 1px, solid, white;\r\n  color: white;\r\n}\r\n\r\n.dropdown-menu .dropdown-item:hover {\r\n  background-color: rgb(46, 44, 44);\r\n  border: 1px, solid, white;\r\n  font-weight: 510;\r\n}\r\n\r\n//Custom CSS for desktop\r\n@media (min-width: 1385px) {\r\n  .navbar-expand-2xl {\r\n    flex-wrap: nowrap !important;\r\n    justify-content: flex-start !important;\r\n  }\r\n\r\n  .navbar-expand-2xl .navbar-collapse {\r\n    display: flex !important;\r\n  }\r\n\r\n  .collapse:not(.show) {\r\n    display: none;\r\n  }\r\n\r\n  .navbar-expand-2xl .navbar-nav {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .navbar-expand-2xl .navbar-toggler {\r\n    display: none;\r\n  }\r\n\r\n  ul li {\r\n    padding-left: 8px;\r\n    padding-left: 8px;\r\n  }\r\n\r\n  .navbar-expand-2xl .navbar-nav .dropdown-menu {\r\n    position: absolute;\r\n  }\r\n\r\n  .mb-lg-0 {\r\n    margin-bottom: 0 !important;\r\n  }\r\n\r\n  .navbar-expand-2xl .navbar-nav .nav-link {\r\n    padding-right: var(--bs-navbar-nav-link-padding-x);\r\n    padding-left: var(--bs-navbar-nav-link-padding-x);\r\n  }\r\n\r\n  a:hover {\r\n    color: white !important;\r\n    font-weight: 510;\r\n    transform: scale(1.03);\r\n  }\r\n}\r\n\r\n//Custom CSS for mobile\r\n\r\n@media (max-width: 1385px) {\r\n  .navbar-toggler {\r\n    background-color: rgb(255, 255, 255);\r\n    color: black;\r\n    padding: 15px;\r\n  }\r\n\r\n  .navbar-collapse {\r\n    flex-basis: 0%;\r\n    flex-grow: 1;\r\n    background-color: rgb(36, 36, 36);\r\n    width: 100%;\r\n    padding-left: 50%;\r\n  }\r\n\r\n  .collapse:not(.show) {\r\n    display: none;\r\n  }\r\n\r\n  .mobile-spacing {\r\n    margin-bottom: 15px;\r\n    margin-top: 15px;\r\n  }\r\n\r\n  .mobile-button {\r\n    padding: 15px;\r\n    font-size: x-large;\r\n  }\r\n\r\n  a {\r\n    font-size: x-large;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
